<script setup lang="ts">
import BaseButton from '../common/BaseButton.vue'
import BriefingBadge from '~/components/badges/BriefingBadge.vue'

type TProps = {
  title: string
  publicationFrequency?: string
  date: string
  slug: string
  viewerCanRead: boolean
  timeToRead: number
  image: string
  excerpt: string
  link: string
}

const props = defineProps<TProps>()
const coverPosition = useCoverPosition(props.image)
</script>

<template>
  <article
    class="group relative !cursor-default bg-warm-gray w-full hover:scale-[1.008] hover:shadow-card-hover hover:z-10 transition-all"
    data-testid="briefing-card"
  >
    <section class="relative w-full grow">
      <!-- Image -->
      <div class="relative w-full">
        <img
          class="h-full w-full object-cover min-h-[165px]"
          :class="coverPosition"
          :src="image"
          :alt="title"
        />
        <BriefingBadge class="absolute top-4 right-4" />
        <div
          class="absolute h-full w-full border-2 border-black/10 group-hover:bg-black/90 inset-0 transition-all duration-500 place-items-center grid opacity-0 group-hover:opacity-100 font-semibold"
        >
          <NuxtLink
            :to="link"
            class="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BaseButton v-if="viewerCanRead"> Read Now </BaseButton>
            <BaseButton v-else variant="unstyled">Find out more</BaseButton>
          </NuxtLink>
        </div>
      </div>
    </section>
    <section class="pt-2.5 px-3 pb-8 flex flex-col gap-2">
      <h3
        class="text-sm font-semibold text-s-900"
        data-testid="presentation-card-title"
      >
        {{ title }}
      </h3>
      <p class="text-xs text-s-700 font-semibold">
        {{ publicationFrequency ? publicationFrequency + ' | ' : '' }}
        {{ date }}
      </p>
      <p class="text-xs text-s-700 line-clamp-2 leading-5" v-html="excerpt" />
      <p class="text-xs text-s-700 font-semibold">
        {{ timeToRead }} minute read
      </p>
    </section>
  </article>
</template>
